<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <app-card>
    <app-datatable
      ref="datatable"
      :btn-dialog="userHasPermission('store')"
      :form-dialog-loading.sync="formDialogLoading"
      :form-dialog.sync="dialog"
      :headers="headers"
      :modal-title="datatableDialogTitle"
      :url="tableUrl"
    >
      <template #formDialog="props">
        <app-form
          ref="form"
          :errors="formErrors"
          :submit="submitForm"
        >
          <v-row>
            <app-file-input
              v-if="!selectedItem.stamp_url"
              v-model="selectedItem.stamp"
              accept="image/*"
              clearable
              cols="12"
              name="stamp"
              sm="6"
            />
            <v-col
              v-else
              cols="12"
              sm="6"
            >
              <v-row
                dense
              >
                <v-col cols="auto">
                  <span class="text-h5">{{ parseAttribute('stamp') }}</span>
                  <app-btn
                    color="error"
                    icon
                    @click="removeStamp"
                  >
                    <v-icon>cancel</v-icon>
                  </app-btn>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="auto">
                  <v-card
                    class="mt-3"
                    color="gray"
                    width="200"
                    height="200"
                  >
                    <v-img
                      contain
                      :lazy-src="AppLogo"
                      :src="selectedItem.stamp_url"
                      max-height="100%"
                      width="200"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <app-text-input
              v-model="selectedItem.name_ar"
              cols="12"
              name="name_ar"
              required
              sm="6"
            />
            <app-text-input
              v-model="selectedItem.name_en"
              cols="12"
              name="name_en"
              required
              sm="6"
            />
            <app-text-input
              v-model="selectedItem.traffics_licence"
              cols="12"
              name="traffics_licence"
              required
              sm="6"
            />
            <app-number-input
              v-model="selectedItem.order_by"
              cols="12"
              name="order_by"
              sm="6"
            />
          </v-row>
          <app-row>
            <app-switcher
              v-model="selectedItem.active"
              cols="auto"
              name="active"
            />
          </app-row>
          <app-row>
            <v-col>
              <app-btn
                :block="AppIsSmall"
                :loading="formDialogLoading"
                @click="submitClickForm"
              >
                {{ $t('save') }}
              </app-btn>
            </v-col>
          </app-row>
        </app-form>
      </template>

      <template #item.stamp="{item}">
        <div class="pa-2">
          <v-card
            :href="item.stamp_url"
            target="_blank"
            color="grey"
            width="50"
            height="50"
          >
            <v-img
              :src="item.stamp_url"
              :lazy-src="AppLogo"
              contain
              width="100%"
              max-height="100%"
            />
          </v-card>
        </div>
      </template>
      <template #item.control="{item}">
        <app-dt-btn
          v-if="userHasPermission('update')"
          update
          @click="showUpdateDialog(item)"
        />
        <app-dt-btn
          v-if="userHasPermission('destroy')"
          destroy
          @click="deleteItem(item)"
        />
      </template>
    </app-datatable>
  </app-card>
</template>
<script>
import { MetaInfoMixin, DatatableMixin } from '@mixins'

export default {
  name: 'Branches',
  helperApiName: 'branch',
  mixins: [MetaInfoMixin, DatatableMixin],
  data () {
    return {
      modelPermission: 'Utilities.Branch',
      headers: [
        {
          text: 'stamp',
          value: 'stamp',
          sortable: !1,
          filterable: !1,
          width: 60
        },
        'name',
        'traffics_licence',
        {
          text: 'status',
          value: 'active_to_string'
        },
        'order_by',
        'control'
      ]
    }
  },
  computed: {
    defaultSelectedItem () {
      return {
        order_by: 0,
        active: !0
      }
    }
  },
  mounted () {
    this.checkPermission('index')
  },
  methods: {
    removeStamp () {
      this.updateSelectedItem({ removeStamp: !0, stamp_url: null })
    }
  }
}
</script>
